export const APP_ROLES = [
  'construction_vendor',
  'case_allocator',
  'reviewer',
  'vendor_manager',
  'acceptance_review_fte',
  'admin',
  'read_only_viewer',
  'national_field_auditor',
  'regional_inspector',
  'inspection_manager',
] as const;
export type AppRole = (typeof APP_ROLES)[number];

export const REQUESTABLE_ROLES: readonly AppRole[] = [
  'construction_vendor',
  'vendor_manager',
  'read_only_viewer',
] as const;

export const ROLE_LABELS: Record<AppRole, string> = {
  construction_vendor: 'Construction Vendor',
  case_allocator: 'Case Allocator',
  reviewer: 'Reviewer',
  vendor_manager: 'Fiber Vendor Manager',
  acceptance_review_fte: 'Acceptance Review - FTE',
  admin: 'Admin',
  read_only_viewer: 'Read-Only Viewer',
  national_field_auditor: 'National Field Auditor',
  regional_inspector: 'Regional Inspector',
  inspection_manager: 'Inspection Manager',
};

export type RoleGroupName = 'Project Acceptance' | 'On-site Inspection' | 'Platform';

export interface RoleGroup {
  readonly label: RoleGroupName;
  readonly roles: readonly AppRole[];
}

export const ROLE_GROUPS: readonly RoleGroup[] = [
  {
    label: 'Project Acceptance',
    roles: [
      'reviewer',
      'vendor_manager',
      'acceptance_review_fte',
      'case_allocator',
      'construction_vendor',
      'read_only_viewer',
    ],
  },
  {
    label: 'On-site Inspection',
    roles: ['national_field_auditor', 'regional_inspector', 'inspection_manager'],
  },
  {
    label: 'Platform',
    roles: ['admin'],
  },
] as const;

export interface RoleOption {
  readonly key: AppRole;
  readonly label: string;
}

export interface RoleOptionGroup {
  readonly label: RoleGroupName;
  readonly roles: readonly RoleOption[];
}

export const ROLE_OPTION_GROUPS: readonly RoleOptionGroup[] = ROLE_GROUPS.map((group) => ({
  label: group.label,
  roles: group.roles.map((key) => ({ key, label: ROLE_LABELS[key] })),
}));

export function isAppRole(value: unknown): value is AppRole {
  return typeof value === 'string' && (APP_ROLES as readonly string[]).includes(value);
}
